import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'

export const deleteMonitoringSite = async ({ siteId }) => {
  await apiClient.delete(`${endpoints.sites}/${siteId}`)
}
